import {
  FilterMode,
  BotPhase_OrderBy,
  BotPhase,
  SortOrder,
  BotPhase_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const botPhaseService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.botPhaseOne({ id });
    return result.botPhaseOne as BotPhase;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: BotPhase_OrderBy[] | null = null,
    filter: BotPhase_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: BotPhase_Filter | undefined;
    if (searchValue !== "") {
      where = {
        phaseName: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.botPhaseListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ phaseName: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.botPhaseListWithOffset
    ) as BotPhase[];
    return { list, orderBy };
  },
};
